/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb2niw_HeadingInputs */

const en_visa_eb2niw_heading = /** @type {(inputs: Visa_Eb2niw_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How We Evaluate NIW Cases`)
};

const pt_visa_eb2niw_heading = /** @type {(inputs: Visa_Eb2niw_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como Avaliamos Casos NIW`)
};

const es_visa_eb2niw_heading = /** @type {(inputs: Visa_Eb2niw_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo Evaluamos Casos NIW`)
};

/**
* | output |
* | --- |
* | "How We Evaluate NIW Cases" |
*
* @param {Visa_Eb2niw_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb2niw_heading = /** @type {((inputs?: Visa_Eb2niw_HeadingInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb2niw_HeadingInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb2niw_heading(inputs)
	if (locale === "es") return es_visa_eb2niw_heading(inputs)
	return en_visa_eb2niw_heading(inputs)
});